export default "__VITE_ASSET__CGOdyn2Y__"